
namespace TabAurous.Purchase {

    @Serenity.Decorators.registerClass()
    export class MaterialInItemsSelectGrid extends _Ext.GridBase<MaterialInItemsRow,any> {
        protected getColumnsKey() { return 'Purchase.MaterialInItemsSelect'; }
        protected getDialogType() { return <any>MaterialInItemsDialog; }
        protected getIdProperty() { return MaterialInItemsRow.idProperty; }
        protected getLocalTextPrefix() { return MaterialInItemsRow.localTextPrefix; }
        //protected getInsertPermission() { return MaterialInItemsRow.insertPermission; }
        //protected getUpdatePermission() { return MaterialInItemsRow.updatePermission; }
        //protected getDeletePermission() { return MaterialInItemsRow.deletePermission; }
        //protected useViewMode() { return true; } 
    
        constructor(container: JQuery,options) {
            super(container, options);           
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            return this;
        }

        private autoSize;
 

        // *** Resizes the columns after changes are made to the grid (ex. Column Picker) *
        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }

        get selectedItems(): MaterialInItemsRow[] {
            var _this = this;
            var c = this.rowSelection.getSelectedAsInt32();
            //.map(function (x) { return _this.view.getItemById(x); });
            return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
        }

        protected usePager() { return false; };
        protected getInitialTitle() { return null; };

        protected getButtons() {
            var buttons = super.getButtons.call(this);
            buttons = buttons.filter(function (x) { return x.cssClass != 'add-button'; });
            return buttons;
        };


        protected onViewSubmit() {

            if (!super.onViewSubmit.call(this))
                return false;
            //var request = this.view.params;
            //if (this.options.hideProducts && this.options.hideProducts.length)
            //    request.Criteria = Serenity.Criteria.and(request.Criteria, [["ProductID" /* ProductID */], 'not in', [this.options.hideProducts]]);
            return true;

        }

    } 
}